import type { PaginationMeta } from '@access-cms/api-client';

export function getTableResultSummary(pagination: Partial<PaginationMeta> | undefined, rowCount: number) {
  if (!pagination || !pagination.page || !pagination.limit || pagination.total === undefined || rowCount === 0) {
    return undefined;
  }

  const start = (pagination.page - 1) * pagination.limit + 1;
  const end = Math.min(start + rowCount - 1, pagination.total);
  const range = `Showing ${start} to ${end} of ${pagination.total} entries`;

  return range;
}
